import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, vShow as _vShow } from "vue";
var _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", {
  "class": "mb-8 text-3xl font-bold"
}, "Campaign Activity", -1);
var _hoisted_2 = {
  "class": "bg-white rounded-md shadow overflow-x-auto mb-6 px-6 py-4 w-full"
};
var _hoisted_3 = /*#__PURE__*/_createElementVNode("tr", null, [/*#__PURE__*/_createElementVNode("td", {
  "class": "py-4 px-2"
}, [/*#__PURE__*/_createElementVNode("label", {
  "class": "block text-gray-700 font-bold"
}, "Tenant")]), /*#__PURE__*/_createElementVNode("td", {
  "class": "py-4 px-2"
}, [/*#__PURE__*/_createElementVNode("label", {
  "class": "block text-gray-700 font-bold"
}, "Campaign")]), /*#__PURE__*/_createElementVNode("td", {
  "class": "py-4 px-2"
}, [/*#__PURE__*/_createElementVNode("label", {
  "class": "block text-gray-700 font-bold"
}, "Start Date")]), /*#__PURE__*/_createElementVNode("td", {
  "class": "py-4 px-2"
}, [/*#__PURE__*/_createElementVNode("label", {
  "class": "ml-2 block text-gray-700 font-bold"
}, "End Date")]), /*#__PURE__*/_createElementVNode("td", {
  "class": "py-4 px-2"
}, [/*#__PURE__*/_createElementVNode("label", {
  "class": "ml-2 block text-gray-700 font-bold"
})])], -1);
var _hoisted_4 = {
  "class": "px-2 pb-4"
};
var _hoisted_5 = ["value"];
var _hoisted_6 = {
  "class": "px-2 pb-4"
};
var _hoisted_7 = ["value"];
var _hoisted_8 = {
  "class": "px-2 pb-4"
};
var _hoisted_9 = {
  "class": "px-2 pb-4"
};
var _hoisted_10 = {
  "class": "px-2 pb-4"
};
var _hoisted_11 = /*#__PURE__*/_createTextVNode(" Aggreagate ");
var _hoisted_12 = {
  "class": "px-2 pb-4"
};
var _hoisted_13 = {
  "class": "bg-white rounded-md shadow overflow-x-auto"
};
var _hoisted_14 = {
  "class": "w-full whitespace-nowrap"
};
var _hoisted_15 = /*#__PURE__*/_createElementVNode("tr", {
  "class": "text-left font-bold"
}, [/*#__PURE__*/_createElementVNode("th", {
  "class": "pb-4 pt-6 px-6"
}, "Name"), /*#__PURE__*/_createElementVNode("th", {
  "class": "pb-4 pt-6 px-6"
}, "Campaign Name"), /*#__PURE__*/_createElementVNode("th", {
  "class": "pb-4 pt-6 px-1"
}, "Time Zone"), /*#__PURE__*/_createElementVNode("th", {
  "class": "pb-4 pt-6 px-1"
}, [/*#__PURE__*/_createElementVNode("div", null, "Contacts"), /*#__PURE__*/_createElementVNode("div", null, "Added")]), /*#__PURE__*/_createElementVNode("th", {
  "class": "pb-4 pt-6 px-1"
}, [/*#__PURE__*/_createElementVNode("div", null, "Companies"), /*#__PURE__*/_createElementVNode("div", null, "Added")]), /*#__PURE__*/_createElementVNode("th", {
  "class": "pb-4 pt-6 px-1"
}, [/*#__PURE__*/_createElementVNode("div", null, "Emails"), /*#__PURE__*/_createElementVNode("div", null, "Sent")]), /*#__PURE__*/_createElementVNode("th", {
  "class": "pb-4 pt-6 px-1"
}, [/*#__PURE__*/_createElementVNode("div", null, "Priority"), /*#__PURE__*/_createElementVNode("div", null, "Count")]), /*#__PURE__*/_createElementVNode("th", {
  "class": "pb-4 pt-6 px-1"
}, [/*#__PURE__*/_createElementVNode("div", null, "Email"), /*#__PURE__*/_createElementVNode("div", null, "Limit")]), /*#__PURE__*/_createElementVNode("th", {
  "class": "pb-4 pt-6 px-1"
}, "Slots"), /*#__PURE__*/_createElementVNode("th", {
  "class": "pb-4 pt-6 px-1"
}, "Date")], -1);
var _hoisted_16 = {
  "class": "border-t"
};
var _hoisted_17 = {
  "class": "flex items-center px-6 py-4"
};
var _hoisted_18 = {
  "class": "border-t"
};
var _hoisted_19 = ["onClick"];
var _hoisted_20 = {
  "class": "border-t"
};
var _hoisted_21 = {
  "class": "flex items-center px-6 py-4"
};
var _hoisted_22 = {
  "class": "border-t"
};
var _hoisted_23 = {
  "class": "flex items-center px-6 py-4"
};
var _hoisted_24 = {
  "class": "border-t"
};
var _hoisted_25 = {
  "class": "flex items-center px-6 py-4"
};
var _hoisted_26 = {
  "class": "border-t"
};
var _hoisted_27 = {
  key: 0,
  "class": "flex items-center px-6 py-4"
};
var _hoisted_28 = ["onClick"];
var _hoisted_29 = {
  key: 1,
  "class": "flex items-center px-6 py-4"
};
var _hoisted_30 = {
  "class": "border-t"
};
var _hoisted_31 = {
  "class": "flex items-center px-6 py-4"
};
var _hoisted_32 = {
  "class": "border-t"
};
var _hoisted_33 = {
  key: 0,
  "class": "flex items-center px-6 py-4"
};
var _hoisted_34 = {
  "class": "border-t"
};
var _hoisted_35 = {
  key: 0,
  "class": "flex items-center px-6 py-4"
};
var _hoisted_36 = {
  "class": "border-t"
};
var _hoisted_37 = {
  "class": "flex items-center px-6 py-4"
};
var _hoisted_38 = {
  key: 0
};
var _hoisted_39 = /*#__PURE__*/_createElementVNode("td", {
  "class": "px-6 py-4 border-t",
  colspan: "7"
}, "No campaigns found.", -1);
var _hoisted_40 = [_hoisted_39];
var _hoisted_41 = {
  "class": "fixed z-[3000] h-full w-full inset-0 bg-gray-800 bg-opacity-90 flex items-center justify-center"
};
var _hoisted_42 = {
  "class": "bg-gray-800 bg-opacity-0 w-1/2 h-1/2 mx-auto rounded-lg flex flex-col justify-center items-center"
};
var _hoisted_43 = {
  "class": "rounded-lg w-full mx-auto bg-white p-6"
};
var _hoisted_44 = {
  "class": "flex justify-center items-center px-4 py-2 w-full"
};
var _hoisted_45 = {
  style: {
    "font-size": "26px"
  },
  "class": "font-bold"
};
var _hoisted_46 = /*#__PURE__*/_createElementVNode("div", {
  "class": "flex justify-between items-center px-4 py-2 w-full"
}, [/*#__PURE__*/_createElementVNode("h2", {
  "class": "font-bold"
}, "CAMPAIGN DATA")], -1);
var _hoisted_47 = {
  "class": "bg-white rounded-md shadow overflow-x-auto mb-6 px-6 py-4 w-full border border-fborder"
};
var _hoisted_48 = {
  "class": "text-left border-b"
};
var _hoisted_49 = /*#__PURE__*/_createElementVNode("td", {
  "class": "pb-2 pt-2 px-6 w-1/2"
}, "Total number of contacts", -1);
var _hoisted_50 = {
  "class": "pb-2 pt-2 px-6"
};
var _hoisted_51 = {
  "class": "text-left"
};
var _hoisted_52 = /*#__PURE__*/_createElementVNode("td", {
  "class": "pb-2 pt-2 px-6 w-1/2"
}, "Total number of companies", -1);
var _hoisted_53 = {
  "class": "pb-2 pt-2 px-6"
};
var _hoisted_54 = /*#__PURE__*/_createElementVNode("div", {
  "class": "flex justify-between items-center px-4 py-2 w-full"
}, [/*#__PURE__*/_createElementVNode("h2", {
  "class": "font-bold"
}, "CAMPAIGN EMAILING")], -1);
var _hoisted_55 = {
  "class": "bg-white rounded-md shadow overflow-x-auto mb-6 px-6 py-4 w-full border border-fborder"
};
var _hoisted_56 = {
  "class": "text-left border-b"
};
var _hoisted_57 = {
  "class": "pb-2 pt-2 px-6 w-1/2"
};
var _hoisted_58 = {
  "class": "pb-2 pt-2 px-6"
};
var _hoisted_59 = {
  "class": "text-left"
};
var _hoisted_60 = /*#__PURE__*/_createElementVNode("td", {
  "class": "pb-2 pt-2 px-6 w-1/2"
}, "Unique Companies Reached", -1);
var _hoisted_61 = {
  "class": "pb-2 pt-2 px-6"
};
var _hoisted_62 = /*#__PURE__*/_createElementVNode("div", {
  "class": "flex justify-between items-center px-4 py-2 w-full"
}, [/*#__PURE__*/_createElementVNode("h2", {
  "class": "font-bold"
}, "UNTOUCHED DATA")], -1);
var _hoisted_63 = {
  "class": "bg-white rounded-md shadow overflow-x-auto mb-6 px-6 py-4 w-full border border-fborder"
};
var _hoisted_64 = {
  "class": "text-left border-b"
};
var _hoisted_65 = /*#__PURE__*/_createElementVNode("td", {
  "class": "pb-2 pt-2 px-6 w-1/2"
}, "Number of contacts", -1);
var _hoisted_66 = {
  "class": "pb-2 pt-2 px-6"
};
var _hoisted_67 = {
  "class": "text-left"
};
var _hoisted_68 = /*#__PURE__*/_createElementVNode("td", {
  "class": "pb-2 pt-2 px-6 w-1/2"
}, "Number of companies", -1);
var _hoisted_69 = {
  "class": "pb-2 pt-2 px-6"
};
var _hoisted_70 = {
  "class": "w-full flex justify-center items-center"
};
var _hoisted_71 = {
  "class": "fixed z-[3000] h-full w-full inset-0 bg-gray-800 bg-opacity-90 flex items-center justify-center"
};
var _hoisted_72 = {
  "class": "bg-gray-800 bg-opacity-0 w-1/2 h-1/2 mx-auto rounded-lg flex flex-col justify-center items-center"
};
var _hoisted_73 = {
  "class": "rounded-lg w-full mx-auto bg-white p-6"
};
var _hoisted_74 = /*#__PURE__*/_createElementVNode("div", {
  "class": "flex justify-between items-center px-4 py-2 w-full"
}, [/*#__PURE__*/_createElementVNode("h2", {
  "class": "font-bold"
}, "FOLLOW UP EMAILING")], -1);
var _hoisted_75 = {
  "class": "bg-white rounded-md shadow overflow-x-auto mb-6 px-6 py-4 w-full border border-fborder"
};
var _hoisted_76 = {
  "class": "text-left border-b"
};
var _hoisted_77 = {
  "class": "pb-2 pt-2 px-6 w-1/2"
};
var _hoisted_78 = {
  "class": "pb-2 pt-2 px-6"
};
var _hoisted_79 = {
  "class": "w-full flex justify-center items-center"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_Head = _resolveComponent("Head");
  var _component_el_checkbox = _resolveComponent("el-checkbox");
  var _component_pagination = _resolveComponent("pagination");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", null, [_createVNode(_component_Head, {
    title: "Campaigns"
  }), _hoisted_1, _createElementVNode("table", _hoisted_2, [_hoisted_3, _createElementVNode("tr", null, [_createElementVNode("td", _hoisted_4, [_withDirectives(_createElementVNode("select", {
    "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
      return $data.form.search = $event;
    }),
    "class": "form-select"
  }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.tenatList, function (tenant, tenant_key) {
    return _openBlock(), _createElementBlock("option", {
      value: tenant.tenant_name
    }, _toDisplayString(tenant.tenant_name), 9, _hoisted_5);
  }), 256))], 512), [[_vModelSelect, $data.form.search]])]), _createElementVNode("td", _hoisted_6, [_withDirectives(_createElementVNode("select", {
    "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
      return $data.form.campaign = $event;
    }),
    "class": "form-select"
  }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.campaignList, function (campaign, campaign_key) {
    return _openBlock(), _createElementBlock("option", {
      value: campaign.campaign_name
    }, _toDisplayString(campaign.campaign_name), 9, _hoisted_7);
  }), 256))], 512), [[_vModelSelect, $data.form.campaign]])]), _createElementVNode("td", _hoisted_8, [_withDirectives(_createElementVNode("input", {
    type: "date",
    "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) {
      return $data.form.start_date = $event;
    }),
    "class": "form-select mt-1 w-40"
  }, null, 512), [[_vModelText, $data.form.start_date]])]), _createElementVNode("td", _hoisted_9, [_withDirectives(_createElementVNode("input", {
    type: "date",
    "onUpdate:modelValue": _cache[3] || (_cache[3] = function ($event) {
      return $data.form.end_date = $event;
    }),
    "class": "ml-2 form-select mt-1 w-40"
  }, null, 512), [[_vModelText, $data.form.end_date]])]), _createElementVNode("td", _hoisted_10, [_createVNode(_component_el_checkbox, {
    modelValue: $data.form.aggregate,
    "onUpdate:modelValue": _cache[4] || (_cache[4] = function ($event) {
      return $data.form.aggregate = $event;
    }),
    size: "large"
  }, null, 8, ["modelValue"]), _hoisted_11]), _createElementVNode("td", _hoisted_12, [_createElementVNode("button", {
    "class": "ml-3 text-white focus:text-indigo-500 text-sm bg-indigo-800 px-6 rounded-md",
    type: "button",
    onClick: _cache[5] || (_cache[5] = function () {
      return $options.reset && $options.reset.apply($options, arguments);
    })
  }, "Reset")])])]), _createElementVNode("div", _hoisted_13, [_createElementVNode("table", _hoisted_14, [_hoisted_15, (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.campaigns.data, function (campaign) {
    return _openBlock(), _createElementBlock("tr", {
      key: campaign.id,
      "class": "hover:bg-gray-100 focus-within:bg-gray-100"
    }, [_createElementVNode("td", _hoisted_16, [_createElementVNode("div", _hoisted_17, _toDisplayString(campaign.tenant_name), 1)]), _createElementVNode("td", _hoisted_18, [_createElementVNode("a", {
      href: "#",
      style: {
        "color": "blue",
        "text-decoration": "underline"
      },
      onClick: function onClick($event) {
        return $options.getCampaignData(campaign);
      }
    }, _toDisplayString(campaign.campaign_name), 9, _hoisted_19)]), _createElementVNode("td", _hoisted_20, [_createElementVNode("div", _hoisted_21, _toDisplayString(campaign.time_zone), 1)]), _createElementVNode("td", _hoisted_22, [_createElementVNode("div", _hoisted_23, _toDisplayString(campaign.contacts_added), 1)]), _createElementVNode("td", _hoisted_24, [_createElementVNode("div", _hoisted_25, _toDisplayString(campaign.companies_added), 1)]), _createElementVNode("td", _hoisted_26, [campaign.follow_up_count.length != 0 ? (_openBlock(), _createElementBlock("div", _hoisted_27, [_createElementVNode("a", {
      href: "#",
      style: {
        "color": "blue",
        "text-decoration": "underline"
      },
      onClick: function onClick($event) {
        return $options.getEmailData(campaign.follow_up_count);
      }
    }, _toDisplayString(campaign.email_sent), 9, _hoisted_28)])) : (_openBlock(), _createElementBlock("div", _hoisted_29, _toDisplayString(campaign.email_sent), 1))]), _createElementVNode("td", _hoisted_30, [_createElementVNode("div", _hoisted_31, _toDisplayString(campaign.priority_count), 1)]), _createElementVNode("td", _hoisted_32, [campaign.campaign_data.emails_per_day_random != 0 ? (_openBlock(), _createElementBlock("div", _hoisted_33, _toDisplayString(campaign.campaign_data.emails_per_day), 1)) : _createCommentVNode("", true)]), _createElementVNode("td", _hoisted_34, [campaign.campaign_data.emails_per_day_random != 0 ? (_openBlock(), _createElementBlock("div", _hoisted_35, _toDisplayString(campaign.campaign_data.emails_per_day_random), 1)) : _createCommentVNode("", true)]), _createElementVNode("td", _hoisted_36, [_createElementVNode("div", _hoisted_37, _toDisplayString(campaign.date), 1)])]);
  }), 128)), $props.campaigns.data.length === 0 ? (_openBlock(), _createElementBlock("tr", _hoisted_38, _hoisted_40)) : _createCommentVNode("", true)])]), _createVNode(_component_pagination, {
    "class": "mt-6",
    links: $props.campaigns.links
  }, null, 8, ["links"])]), _withDirectives(_createElementVNode("div", _hoisted_41, [_createElementVNode("div", _hoisted_42, [_createElementVNode("div", _hoisted_43, [_createElementVNode("div", _hoisted_44, [_createElementVNode("h1", _hoisted_45, _toDisplayString($data.campaignData.campaign_name) + " - AGGREGATE DATA", 1)]), _hoisted_46, _createElementVNode("table", _hoisted_47, [_createElementVNode("tr", _hoisted_48, [_hoisted_49, _createElementVNode("td", _hoisted_50, _toDisplayString($data.campaignData.total_contacts), 1)]), _createElementVNode("tr", _hoisted_51, [_hoisted_52, _createElementVNode("td", _hoisted_53, _toDisplayString($data.campaignData.total_companies), 1)])]), _hoisted_54, _createElementVNode("table", _hoisted_55, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.campaignData.follow_up_data, function (follow_up) {
    return _openBlock(), _createElementBlock("tr", _hoisted_56, [_createElementVNode("td", _hoisted_57, _toDisplayString(_ctx.$helpers.stringifyNumber(follow_up.follow_up_order)), 1), _createElementVNode("td", _hoisted_58, _toDisplayString(follow_up.follow_up_count), 1)]);
  }), 256)), _createElementVNode("tr", _hoisted_59, [_hoisted_60, _createElementVNode("td", _hoisted_61, _toDisplayString($data.campaignData.unique_companies), 1)])]), _hoisted_62, _createElementVNode("table", _hoisted_63, [_createElementVNode("tr", _hoisted_64, [_hoisted_65, _createElementVNode("td", _hoisted_66, _toDisplayString($data.campaignData.untouched_contacts), 1)]), _createElementVNode("tr", _hoisted_67, [_hoisted_68, _createElementVNode("td", _hoisted_69, _toDisplayString($data.campaignData.untouched_companies), 1)])]), _createElementVNode("div", _hoisted_70, [_createElementVNode("button", {
    "class": "ml-3 text-white focus:text-indigo-500 text-sm bg-indigo-800 px-6 py-2 rounded-md",
    onClick: _cache[6] || (_cache[6] = function ($event) {
      return $data.showCampaignData = false;
    })
  }, "Ok")])])])], 512), [[_vShow, $data.showCampaignData]]), _withDirectives(_createElementVNode("div", _hoisted_71, [_createElementVNode("div", _hoisted_72, [_createElementVNode("div", _hoisted_73, [_hoisted_74, _createElementVNode("table", _hoisted_75, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.emailData, function (follow_up) {
    return _openBlock(), _createElementBlock("tr", _hoisted_76, [_createElementVNode("td", _hoisted_77, _toDisplayString(_ctx.$helpers.stringifyNumber(follow_up.follow_up_order)), 1), _createElementVNode("td", _hoisted_78, _toDisplayString(follow_up.follow_up_count), 1)]);
  }), 256))]), _createElementVNode("div", _hoisted_79, [_createElementVNode("button", {
    "class": "ml-3 text-white focus:text-indigo-500 text-sm bg-indigo-800 px-6 py-2 rounded-md",
    onClick: _cache[7] || (_cache[7] = function ($event) {
      return $data.showEmailData = false;
    })
  }, "Ok")])])])], 512), [[_vShow, $data.showEmailData]])], 64);
}